/* istanbul ignore file */
import React from 'react';

import isNil from 'lodash/isNil';

import { isFeatureEnabled } from '@lumapps/features';
import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { useSelector } from '@lumapps/redux/react';
import { isConnectedAs } from '@lumapps/user/ducks/selectors';

import { CONCURRENT_ACCESS_FEATURE_TOKEN } from '../../constants';

const LazyContentLease = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'content-lease' */
            './ContentLease'
        ),
);

export const ContentLease = (props: React.ComponentProps<typeof LazyContentLease>) => {
    /** Content props are required but passed on from the legacy. So anything can be expected. */
    const { id, version } = props;
    const hasContentProps = Boolean(id && !isNil(version));

    /** Get feature requirements. */
    const connectedAs = useSelector(isConnectedAs);
    const concurrentAccessFeatureEnabled = useSelector(isFeatureEnabled(CONCURRENT_ACCESS_FEATURE_TOKEN));

    /**
     * ‼️‼️‼️ WARNING ‼️‼️‼️
     * This feature should NEVER be available for user connected with an as.
     * ‼️‼️‼️ WARNING ‼️‼️‼️
     * */
    const featureAvailable = !connectedAs && concurrentAccessFeatureEnabled;

    /**
     * If the feature is not available. Or the content not complete.
     * Do not load.
     * */
    if (!featureAvailable || !hasContentProps) {
        return null;
    }

    return (
        <Suspense isDialog>
            <LazyContentLease {...props} />
        </Suspense>
    );
};
